import {UI} from "../../../../../../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../../../../../../stem-core/src/ui/Style";
import {PopupMenu} from "../../../../../../ui/PopupMenu.jsx";
import {Messages} from "../../../../../../Messages";
import {registerStyle} from "../../../../../../../stem-core/src/ui/style/Theme";
import {EditAddressModal} from "./EditAddressModal";
import {DeleteAddressModal} from "./DeleteAddressModal";
import {AddressInUseModal} from "./AddressInUseModal";
import {SubscriptionStore} from "../../../../../../../client/state/SubscriptionStore";
import {unwrapArray} from "../../../../../../../stem-core/src/base/Utils.js";


class AddressListItemStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
        overflow: "initial !important",
    };

    @styleRule
    addressLine = {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
}

@registerStyle(AddressListItemStyle)
export class AddressListItem extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            address: null,
        }
    }

    promptEdit() {
        const {address} = this.options;

        if (SubscriptionStore.getActiveWithAddress(address).length) {
            AddressInUseModal.show({address});
            return;
        }
        EditAddressModal.show({address});
    }

    promptDelete() {
        const {address} = this.options;

        if (SubscriptionStore.getActiveWithAddress(address).length) {
            AddressInUseModal.show({address});
            return;
        }
        DeleteAddressModal.show({address});
    }

    getMenuItems({allowEdit = true, allowDelete = true} = {}) {
        return unwrapArray([
            allowEdit && {
                content: Messages.edit,
                onClick: () => this.promptEdit(),
            },
            allowDelete && {
                content: Messages.deleteMessage,
                onClick: () => this.promptDelete(),
            }]);
    }

    render() {
        const {address} = this.options;

        return [
            <span className={this.styleSheet.addressLine}>{address}</span>,
            <PopupMenu items={this.getMenuItems()}/>
        ]
    }
}
